import React, { useEffect, useState } from "react";
import useAlphabeticInput from "../../hooks/useAlphabeticInput";
import useNumericInput from "../../hooks/useNumericInput";
import { showError, showSuccess } from "../../utils/toastUtils";
import userAPI from "../../api/UserApi";
import { FiUser, FiMail, FiPhone, FiCheckCircle } from "react-icons/fi";

function Account() {
  useAlphabeticInput();
  useNumericInput();

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    phone: "",
    firstName: "",
    lastName: "",
    email: "",
  });

  useEffect(() => {
    fetchMyDetails();
  }, []);

  const fetchMyDetails = async () => {
    try {
      const res = await userAPI.getDetails();
      if (res.code === 200) {
        const result = res.data;
        setFormData({
          phone: result?.mobile || "",
          firstName: result?.firstName || "",
          lastName: result?.lastName || "",
          email: result?.email || "",
        });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.firstName) newErrors.firstName = "Please Enter First Name";
    if (!formData.phone) newErrors.phone = "Please Enter Phone Number";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleDetailsSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const res = await userAPI.updateDetails(formData);
      if (res.code === 200) {
        showSuccess(res.message);
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <div className="account-details-funky">
      <div className="account-card-wrapper">
        {/* Component Title Sticker */}
        <div className="account-card-header mb-4">
          <span className="badge-text-yellow">MY PROFILE</span>
          <h4 className="account-title mt-2">Account Details</h4>
        </div>

        <form onSubmit={handleDetailsSubmit}>
          {/* NAME ROW */}
          <div className="row g-4 mb-4">
            <div className="col-md-6">
              <label className="funky-dash-label">First Name <span className="text-danger">*</span></label>
              <div className="funky-dash-input-box">
                <FiUser className="input-icon-left" />
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="funky-dash-input only-alphabets"
                  placeholder="First Name"
                />
              </div>
              {errors.firstName && (
                <small className="text-danger d-block mt-1 fw-bold">{errors.firstName}</small>
              )}
            </div>

            <div className="col-md-6">
              <label className="funky-dash-label">Last Name</label>
              <div className="funky-dash-input-box">
                <FiUser className="input-icon-left" />
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  className="funky-dash-input only-alphabets"
                  placeholder="Last Name"
                />
              </div>
            </div>
          </div>

          {/* EMAIL & CONTACT ROW */}
          <div className="row g-4 mb-4">
            <div className="col-md-6">
              <label className="funky-dash-label">Email Address</label>
              <div className="funky-dash-input-box locked">
                <FiMail className="input-icon-left" />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  readOnly
                  className="funky-dash-input"
                  style={{ cursor: "not-allowed" }}
                />
              </div>
              <div className="funky-note-sticker mt-2">
                🔒 Note: Email address is verified and locked.
              </div>
            </div>

            <div className="col-md-6">
              <label className="funky-dash-label">Phone Number <span className="text-danger">*</span></label>
              <div className="funky-dash-input-box">
                <FiPhone className="input-icon-left" />
                <input
                  type="text"
                  name="phone"
                  value={formData.phone}
                  maxLength={10}
                  onChange={handleChange}
                  className="funky-dash-input only-numeric"
                  placeholder="10 Digit Number"
                />
              </div>
              {errors.phone && (
                <small className="text-danger d-block mt-1 fw-bold">{errors.phone}</small>
              )}
            </div>
          </div>

          {/* SAVE BUTTON */}
          <div className="mt-4 pt-2">
            <button className="account-save-btn" type="submit">
              UPDATE DETAILS <FiCheckCircle className="ms-2" />
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Account;